document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector("#tee-artwork-form");
  const insertAfterElement = document.querySelector(
    ".teeinblue-enabled buy-buttons form"
  );

  if (elementToMove && insertAfterElement) {
    insertAfterElement.insertBefore(
      elementToMove,
      insertAfterElement.firstChild
    );
  }
});
document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove1 = document.querySelector(
    ".teeinblue-enabled variant-picker"
  );
  const insertAfterElement1 = document.querySelector(
    ".teeinblue-enabled buy-buttons form"
  );

  if (elementToMove1 && insertAfterElement1) {
    insertAfterElement1.insertBefore(
      elementToMove1,
      insertAfterElement1.firstChild
    );
  }
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove2 = document.querySelector(".tee-campaign-form-footer");
  const insertAfterElement2 = document.querySelector(
    ".quantity-submit-row__submit.input-row.xbg.tee-form-wrapper"
  );

  if (elementToMove2 && insertAfterElement2) {
    insertAfterElement2.insertBefore(
      elementToMove2,
      insertAfterElement2.firstChild
    );
  }
});
